<template>
  <svg viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <linearGradient
        id="seedling-gradient"
        x1="0%"
        y1="0%"
        x2="100%"
        y2="100%"
      >
        <stop offset="0%" stop-color="#5DCAA5" />
        <stop offset="100%" stop-color="#1D9E75" />
      </linearGradient>
    </defs>
    <rect
      ref="soil1Ref"
      class="soil-1"
      x="20"
      y="60"
      width="40"
      height="8"
      rx="4"
      fill="#1D9E75"
      opacity="0.25"
    />
    <rect
      ref="soil2Ref"
      class="soil-2"
      x="24"
      y="62"
      width="32"
      height="5"
      rx="2.5"
      fill="#1D9E75"
      opacity="0.4"
    />
    <path
      ref="stemRef"
      class="stem"
      d="M40 64 C40 64 40 50 40 38"
      stroke="url(#seedling-gradient)"
      stroke-width="3"
      stroke-linecap="round"
    />
    <g ref="leafLeftRef" class="leaf-left">
      <path
        d="M40 44 C40 44 28 40 26 30 C26 30 38 30 40 44Z"
        fill="url(#seedling-gradient)"
        opacity="0.85"
      />
    </g>
    <g ref="leafRightRef" class="leaf-right">
      <path
        d="M40 36 C40 36 52 30 56 20 C56 20 44 22 40 36Z"
        fill="url(#seedling-gradient)"
      />
    </g>
    <circle ref="sp1Ref" class="sp1" cx="20" cy="28" r="2.5" fill="#5DCAA5" />
    <circle ref="sp2Ref" class="sp2" cx="62" cy="36" r="2" fill="#7F77DD" />
    <circle ref="sp3Ref" class="sp3" cx="58" cy="18" r="3" fill="#5DCAA5" />
    <circle ref="sp4Ref" class="sp4" cx="16" cy="44" r="2" fill="#1D9E75" />
  </svg>
</template>

<script setup>
import { ref } from 'vue';

const soil1Ref = ref(null);
const soil2Ref = ref(null);
const stemRef = ref(null);
const leafLeftRef = ref(null);
const leafRightRef = ref(null);
const sp1Ref = ref(null);
const sp2Ref = ref(null);
const sp3Ref = ref(null);
const sp4Ref = ref(null);

const animate = () => {
  [
    soil1Ref.value,
    soil2Ref.value,
    stemRef.value,
    leafLeftRef.value,
    leafRightRef.value,
    sp1Ref.value,
    sp2Ref.value,
    sp3Ref.value,
    sp4Ref.value,
  ].forEach((el) => {
    if (!el) return;
    el.style.animation = 'none';
    void el.offsetHeight;
    el.style.animation = '';
  });
};

defineExpose({ animate });
</script>

<style scoped>
.soil-1 {
  animation: soilIn 0.4s ease-out 0.1s both;
  transform-origin: center;
}

.soil-2 {
  animation: soilIn 0.4s ease-out 0.2s both;
  transform-origin: center;
}

@keyframes soilIn {
  from {
    transform: scaleX(0);
    opacity: 0;
  }
  to {
    transform: scaleX(1);
    opacity: 1;
  }
}

.stem {
  stroke-dasharray: 60;
  stroke-dashoffset: 60;
  animation: growStem 0.6s ease-out 0.4s forwards;
}

@keyframes growStem {
  to {
    stroke-dashoffset: 0;
  }
}

.leaf-left {
  transform-origin: 38px 42px;
  transform: scale(0) rotate(-20deg);
  animation: leafPop 0.5s cubic-bezier(0.34, 1.56, 0.64, 1) 0.9s forwards;
}

.leaf-right {
  transform-origin: 42px 34px;
  transform: scale(0) rotate(20deg);
  animation: leafPop 0.5s cubic-bezier(0.34, 1.56, 0.64, 1) 1.1s forwards;
}

@keyframes leafPop {
  to {
    transform: scale(1) rotate(0deg);
  }
}

.sp1 {
  animation: sparklePop 0.4s cubic-bezier(0.34, 1.56, 0.64, 1) 1.4s both;
  transform-origin: center;
}
.sp2 {
  animation: sparklePop 0.4s cubic-bezier(0.34, 1.56, 0.64, 1) 1.6s both;
  transform-origin: center;
}
.sp3 {
  animation: sparklePop 0.4s cubic-bezier(0.34, 1.56, 0.64, 1) 1.5s both;
  transform-origin: center;
}
.sp4 {
  animation: sparklePop 0.4s cubic-bezier(0.34, 1.56, 0.64, 1) 1.7s both;
  transform-origin: center;
}

@keyframes sparklePop {
  0% {
    transform: scale(0);
    opacity: 0;
  }
  60% {
    opacity: 1;
  }
  100% {
    transform: scale(1);
    opacity: 0.7;
  }
}
</style>
